<template>
  <div class="home">
	  <el-container >
		   <div style="height:50px;z-index: 9999;width:100%;background:#f6f6f6 none repeat scroll 0% 0%;color: white;">
			   <div style="width:150px;line-height: 50px;background: rgb(20,145,254);height:50px;float: left;text-align: center;color: white;font-size: 12px;">
				    <span style=" font-size:12px;display:inline-block;vertical-align:middle;line-height:1.4;">订单
				 　　	<br />管理平台
			　　　  </span>
				</div>
			   <div style="height:50px;float: left;width: calc(100% - 200px);text-align: left;text-align: center;color: black;" >
				   <el-row >
				     <el-col :span="1" >
						 <div class="grid-content bg-purple-dark" @click="fold" style="text-align: center;font-size: 12px;line-height: 50px;">
							<i class="el-icon-s-unfold" ></i> 
						 </div>
					 </el-col>
					 
					 <el-col :span="13" >
						 <div class="grid-content bg-purple-dark" @click="fold" style="text-align: left;font-size: 12px;line-height: 50px;">
							您好，订单后台
						 </div>
					 </el-col>
					 
					 <el-col :span="10" style="font-size: 12px;">
						 <div class="grid-content bg-purple-dark" style="text-align: right;">
							<span style="line-height: 50px;">
							</span>
						   <!-- <span style="line-height: 50px;">任务提醒</span> -->
						   <!-- <div style="float: right;height: 50px;line-height: 35px;">
							   <span style="border-radius: 50%;background: red;color: white;padding: 0px 2px;font-size: 8px;line-height:none">1</span> 
						   </div> -->
						 </div>
					 </el-col>
				   </el-row>
			   </div>
		   </div>
	    <el-container>
	        <el-aside width="none" style="background: black">
				<el-menu default-active="Task"  class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSelect"
					background-color="black"   text-color="white" active-text-color="white"  :collapse="isCollapse" >
					<el-menu-item index="carousel">
					    <i class="el-icon-picture-outline" style="font-size: 0.875rem;"></i>
					    <span slot="title" class="menu_text">轮播</span>
					</el-menu-item>
					<el-submenu index="2">
						<template slot="title">
						    <i class="el-icon-present" style="font-size: 0.875rem;"></i>
						    <span class="menu_text">商品</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="goodsclassify" >
								<i class="el-icon-upload" style="font-size: 0.875rem;"></i>
								<span slot="title" class="menu_text">商品分类</span>
							</el-menu-item>
							<!-- <el-menu-item index="goodsnorms" >
								<i class="el-icon-circle-plus" style="font-size: 0.875rem;"></i>
								<span slot="title" class="menu_text">商品规格</span>
							</el-menu-item> -->
							<el-menu-item index="goods" >
								<i class="el-icon-circle-plus" style="font-size: 0.875rem;"></i>
								<span slot="title" class="menu_text">商品详情</span>
							</el-menu-item>
							<!-- <el-menu-item index="test" >
								<i class="el-icon-circle-plus" style="font-size: 0.875rem;"></i>
								<span slot="title" class="menu_text">测试上传</span>
							</el-menu-item> -->
						</el-menu-item-group>
					</el-submenu>
					<el-menu-item  index="order" >
					    <i class="el-icon-s-grid" style="font-size: 0.875rem;"></i>
					    <span slot="title" class="menu_text">订单</span>
					</el-menu-item>
					<el-menu-item  index="user" >
					    <i class="el-icon-s-custom" style="font-size: 0.875rem;"></i>
					    <span slot="title" class="menu_text">用户</span>
					</el-menu-item>
					<el-menu-item  index="data" >
					    <i class="el-icon-s-marketing" style="font-size: 0.875rem;"></i>
					    <span slot="title" class="menu_text">数据</span>
					</el-menu-item>
				</el-menu>
			</el-aside>
			<el-main>
			  <router-view/>
		  </el-main>
	    </el-container>
	  </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
import {UploadZZD} from '@/request/commom.js'
import {get,post} from '@/request/http.js'
export default {
  name: 'home',
  data(){
	  return {
		  key:'/',
		  isCollapse: false,
		  circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
		  task_schedule_show:false,
		  task_show:false,
		  userinfo:{},
		  now_year_str:''
	  }
  },
  methods:{
	handleCommand(command,label){
		
	},
	handleOpen(key, keyPath) {
	  // console.log(key, keyPath);
	},
	handleClose(key, keyPath) {
	  // console.log(key, keyPath);
	},
	handleSelect(key, keyPath,el){
		if(this.key==key){
			return 
		}
		this.key=key;
		this.$router.push({name:this.key,params:{title:el.$el.innerText}}).catch(data =>{})
	},
	fold(){
		this.isCollapse=!this.isCollapse
	}
	
  },
  mounted() {
  }
}
</script>
<style>
	.el-menu-item-group__title{
		padding: 0px !important;
	}
</style>
<style scoped="scoped">
  .el-menu-item-group__title{
	padding: 0px;
  }
 .el-header, .el-footer {
	background-color: #B3C0D1;
	color: #333;
	text-align: center;
	line-height: 60px;
	padding: 0px;
  }
  
  .el-aside {
	background-color: #D3DCE6;
	color: #333;
	line-height: 200px;
	text-align: left;
  }
  
  .el-main {
	background-color: rgb(243,243,243);
	color: #333;
	/* line-height: 160px; */
  }
  .el-container{
    position: absolute; 
    width: 100%; 
    top: 0px ; 
    left: 0 ; 
    bottom: 0;
  }
  .el-header{
    padding: 0;
    z-index: 1000;
  }
  
  .el-header .fr{
    float: right;
  }
  .el-header .el-menu{
    border-bottom: none;
  }
  .el-aside, .el-main{
    padding-top: 50px;
  }
  .el-aside{
    background: #fff;
  }
  .el-aside .el-menu{
    border-right: none;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 150px;
    min-height: 400px;
  }
  .menu_text{
	  font-size: 12px;
  }
  .icon{
	  font-size: 12px;
  }
</style>
<style>
	.el-badge__content.is-fixed{
		  transform:translateY(0%) translateX(100%) !important;
	}
	.el-badge__content{
		line-height:13px !important;
		height: 13px !important;
	}
	.el-dropdown-link {
	    cursor: pointer;
	    color: #409EFF;
	  }
</style>
